import React, { useContext } from 'react';
import classNames from 'classnames';
import styles from './filtersButton.module.pcss';
import PlusSignIcon from '../../../../../../../svg/icons/rolex/rolex-plus-sign.svg';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';

interface FiltersButtonProps {
  isListerDisabled: boolean;
  facetsDisplayHandler: () => void;
}

function FiltersButton({ isListerDisabled, facetsDisplayHandler }: FiltersButtonProps): React.ReactElement {
  const [formattedMessage] = useContext(MessagePropertiesContext);
  return (
    <button
      type="button"
      disabled={isListerDisabled}
      onClick={facetsDisplayHandler}
      className={classNames(
        'rolex-button rolex-button--white rolex-spacing-20 hide-global-rolex-lg-up',
        styles['filters-button']
      )}
    >
      <span>{formattedMessage({ id: 'rolex.plp.filtersButton', fallback: 'Filters' })}</span>
      <PlusSignIcon />
    </button>
  );
}

export default FiltersButton;
